import React, { useEffect, useState } from 'react';


import Carousel from '../Carousel/Carousel';

import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import Slide from '../Slide/Slide';
// import ModalConvocatoria from '../Modal/ModalConvocatoria';
import './inicio.css';

import { titular } from '../../json/titular';
import { culturaOrganizativa_item } from '../../json/culturaOrganizativa';
import { Link } from 'react-router-dom';
import { carouselInicio } from '../../json/carousel';


const Inicio = () => {
   const [isModalOpen, setModalOpen] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    const closeModal = () => {
      setModalOpen(false);
    };
  return (
    <>
      <Carousel bannerData={carouselInicio} search={false} name="banner-principal" />
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='secretaria_logo' >
              <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Gobierno.svg")` }}>

              </div>
            </div>
          </div>
          <div className='secretaria_name'>
            <h1>UNIDAD DE PLANEACIÓN Y PROSPECTIVA</h1>
          </div>
          <div className='secretaria_funciones'>
            <h3 className='title'>ATRIBUCIONES</h3>
            <hr className='hr-gob'/>
          
            <p> La Unidad conducirá sus actividades en forma programada y de conformidad con las políticas,
                lineamientos, estrategias, programas y prioridades que para el logro de sus objetivos y metas, establezca la Persona
                Titular del Poder Ejecutivo del Estado y la o el titular de la Unidad, en concordancia con los Planes de Desarrollo
                Nacional y Estatales. </p>
            
            <div id="global">
              
                <div>  
                  <ol className= "romanos">            
                    <li> Fomentar y atender la participación ciudadana en la configuración de las políticas para la planeación
                        democrática conforme a los mecanismos establecidos; </li> 
                    <li>Considerar la opinión de las autoridades federales, estatales y municipales, a fin de promover e impulsar el
                          desarrollo estatal, municipal, regional y metropolitano.</li>   
                    <li>Coordinar e implementar la política en materia de mejora regulatoria, para dar cumplimiento al Plan Estatal.</li>                 
                 </ol>   
                </div>             
            </div>
           
            <div className='btn_organigrama'>
            
                <a href="/Transparencia/Rubros/DetalleRubro/1.%20Normatividad">
                <button type="button" class="btn btn-primary">Normatividad</button>
                </a>
                <a href="/Transparencia/Rubros/DetalleRubro/2.%20Estructura">
                <button type="button" className="btn btn-primary">Organigrama</button>                
                </a>               
              </div>
              <div className='secretaria-redes'>
                <a href='https://www.facebook.com/profile.php?id=100069229599131'><i class="fa-brands fa-facebook-f"></i></a>
                {/* <a href=''><i class="fa-brands fa-instagram"></i></a> */}
                <a href='https://twitter.com/planeacionhgo?s=11&t=oB2o1hjPKUwNl7LxPvvJnQ'><i class="fa-brands fa-twitter"></i></a>
              </div>
          </div>          
         
    {/* <h3 class="title">Cultura Organizativa</h3>
      <hr class="hr-gob"/> */}
      {/* {
                culturaOrganizativa_item.map((item, index)=>(
                  
                    <div key={ index } className='col-md'>                        
                        <div className='card' >
                          <div className='card-body'>
                            <div className='card-title card-cultura'>
                              <h5> { item.cultura_item_nombre }</h5>
                              <p className='card-text'>{item.cultura_item_descripcion}</p> 
                            </div>
                          </div>
                        </div>
                    </div>             
                  
                ))
            } */}
            <h3 class="title">Misión</h3>
             <hr className='hr-gob'/>
                <p> La Unidad de Planeación y Prospectiva es una dependencia del Poder Ejecutivo, encargada del proceso de 
                  planeación del desarrollo estatal, basándose en instrumentos y mecanismos de políticas públicas 
                  con un enfoque estratégico y prospectivo para impulsar el desarrollo en el Estado. </p>

            <h3 class="title">Visión</h3>
             <hr className='hr-gob'/>
                <p> Mejorar las condiciones de bienestar de la población hidalguense a través de la evaluación y seguimiento 
                    a los instrumentos de planeación para asegurar el cumplimiento de los objetivos de política pública</p>

            <h3 class="title">Objetivo General</h3>
             <hr className='hr-gob'/>
                <p> Coordinar los procesos de planeación para el desarrollo, así como de monitoreo y evaluación de las políticas 
                  públicas.</p>




            
                            
          <div class="row">
            

            
 {/* <div>
  <h3 class="title">Indicadores</h3>
  <hr class="hr-gob"/>
 </div>
  <div class="col-md fxindicador">
    <div class="col-md indicador">
      <div>100.00%</div>Mecanismos Instrumentados para el Sistema Estatal de Monitoreo y Evaluación.</div>
    <div class="col-md indicador">
     <div>44.70%</div>Indicador.</div>
    <div class="col-md indicador">
     <div>156.30%</div>Indicador..</div>
   </div>*/}
</div> 






        </div>
        
        
        {/* <UltimasNoticias /> */}
        <Slide />
     

        

        <div className='row'>
          <div className='col-12'>
            <div className='notes_title'>
              <h3 className='title'>TITULAR DE LA UNIDAD DE PLANEACIÓN Y PROSPECTIVA</h3>
              <hr className='hr-gob'/>
            </div>
            <div className='section_notes'>
              {
                titular.map((item, index) =>(
                    <>
                      <div key={ index } className='sec_photo'>
                        <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                        </div>
                      </div>
                      <div className='sec_container'>
                        <div className='sec_name'>
                          <h3>{ item.nombre }</h3>
                        </div>
                        <div className='sec_function'>
                          {/* <h4>Función del Secretario</h4> 
                          <p>{ item.funcion }</p>
                          <p>{ item.funcion2 }</p>
                          <p>{ item.funcion3 }</p> */}
                          <div className='btn_agenda'>
                            <Link to="Agenda">Conoce la agenda del Secretario</Link>
                          </div>
                        </div>
                      </div>
                    </>
                ))
              }
            </div>
          </div>
        </div>

        {/* <ModalConvocatoria isOpen={isModalOpen} onClose={closeModal} /> */}

        <div className='row'>
          <div className='col-12'>
            <div className='section_map'>
              <div className='map_name'>
                <h3 className='title'>UBICACIÓN</h3>
                <hr className='hr-gob'/>
              </div>
              <iframe src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=es&amp;q=palacio%20de%20gobierno%20pachuca%20hidalgo+(Mi%20nombre%20de%20egocios)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                      width="100%" 
                      height="300" 
                      frameborder="0" 
                      style={{border:0, marginBottom:50}} 
                      allowfullscreen>
              </iframe>
            </div>
          </div>
        </div>   
      </div>
    </>
  )
}

export default Inicio